import React, {useEffect,useState} from 'react'
import {useLocation} from 'react-router-dom';
import QRCode from 'qrcode';
import { Container, Row, Col,Button} from "reactstrap";

function PrintQRCode() {
    const [image, setImage] = useState();
    const location = useLocation()
    useEffect(()=>{
        generateQRCode()
    },[])
    const prod = location.state.prod
    const generateQRCode = async ()=>{
        try{
            /* delete prod.__v
            delete prod.priceStaff
            delete prod.updatedAt
            delete prod.staff
            delete prod.createdAt
            const data = JSON.stringify(prod) */
            
            const resp = await QRCode.toDataURL(prod._id)
            setImage(resp)
        }catch(err){
            console.log(err)
        }
    }
    
    const sizeHandler =(size)=>{
        switch (size) {
            case 'XXL':
                return '2XL'
                break;
            case 'XXXL':
                return '3XL'
                break;
            case 'XXXXL':
                return '4XL'
                break;
            default:
                return size
                break;
        }
    }
    
  return (
    <Container>
        <Row className='text-center' >
            <Col>
                <img src={image} alt="qrcode" width="300" className="align-self-center" /><br/>
                <span>{prod.house}</span><br/>
                <span>{prod.desc}</span><br/>
                <span>{sizeHandler(prod.size)}</span><br/>
                <span>{prod.color}</span><br/>
                <span>{prod.price}€</span><br/>
            </Col>
        </Row>
    </Container>
  )
}

export default PrintQRCode